import PropTypes from "prop-types";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

import { useKeikkaData } from "src/context/KeikkaDataContext";
import { useUserData } from "src/context/userContext";
import { useEffect, useState } from "react";

import KeikkaIcon2 from "../keikka/keikkaIcon/KeikkaIcon2";
import MyDivider from "../layout/MyDivider";
import ShowChildren from "../system/ShowChildren";
import { ArrowForwardIcon } from "../icons/ArrowIcons";
import {
  AsetuksetIcon,
  HinnatIcon,
  KuvatIcon,
  LokiIcon,
  SeurantaIcon,
  TilausIcon,
  ToiminnotIcon,
  ToimitusIcon,
} from "../icons/StepIcons";
import { TarjousIcon } from "../icons/TarjousIcons";

const styles = {
  arrowForward: {
    fontSize: "12px",
    opacity: 0.8,
  },
};

function EdgeDrawer(props) {
  const { user, userAsiakas, auth } = useUserData();
  const { keikkaData } = useKeikkaData();
  const fontSize = "26px";

  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
    props.onClose();
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const tilausClick = () => {
    props.onClick(0);
    toggleDrawer(false);
  };
  const toimitusClick = () => {
    props.onClick(7);
    toggleDrawer(false);
  };
  const kuvatClick = () => {
    props.onClick(4);
    toggleDrawer(false);
  };
  const toiminnotClick = () => {
    props.onClick(1);
    toggleDrawer(false);
  };
  const viestitClick = () => {
    props.onClick(3);
    toggleDrawer(false);
  };
  const processClick = () => {
    props.onClick(5);
    toggleDrawer(false);
  };
  const hintaClick = () => {
    props.onClick(6);
    toggleDrawer(false);
  };
  const tarjousClick = () => {
    props.onClick(9);
    toggleDrawer(false);
  };
  const asetuksetClick = () => {
    props.onClick(8);
    toggleDrawer(false);
  };

  if (!keikkaData) return <>NO KEIKKADATA</>;
  const keikkaDataAuth = auth.keikkaDataAuth(keikkaData, user, userAsiakas);

  const renderList = () => (
    <Box sx={{ width: 200 }} role="presentation" onClick={toggleDrawer(false, false)}>
      <div className="spaceAround">
        <KeikkaIcon2 keikkaData={keikkaData} size={120} noAnimation />
      </div>
      <Typography variant="h6" align="center" color="primary">
        Tilauksen tiedot
      </Typography>
      <MyDivider />
      <List>
        {renderTilaus()}
        {keikkaDataAuth.modules.toimitus.read && renderToimitus()}
        {keikkaDataAuth.modules.kuvat.read && renderKuvat()}
        {renderSeuranta()}
        <ShowChildren
          criteriaBool={keikkaDataAuth.modules.lasku.read}
          criteriaTxt="keikkaDataAuth.modules.lasku.read"
          source="EdgeDrawer">
          <MyDivider chipText="Laskutus" />
        </ShowChildren>

        <ShowChildren
          criteriaBool={keikkaDataAuth.modules.lasku.read}
          criteriaTxt="keikkaDataAuth.modules.lasku.read"
          source="EdgeDrawer">
          {renderTarjous()}
        </ShowChildren>
        <ShowChildren
          criteriaBool={keikkaDataAuth.modules.lasku.read}
          criteriaTxt="keikkaDataAuth.modules.lasku.read"
          source="EdgeDrawer">
          {renderLaskutus()}
        </ShowChildren>

        <ShowChildren
          criteriaBool={keikkaDataAuth.toiminnot.read}
          criteriaTxt="keikkaDataAuth.toiminnot.read"
          source="EdgeDrawer">
          <MyDivider chipText="Tehtävät" />
          {renderToiminnot()}
        </ShowChildren>

        <ShowChildren
          criteriaBool={keikkaDataAuth.viestit.read}
          criteriaTxt="keikkaDataAuth.viestit.read"
          source="EdgeDrawer">
          <MyDivider chipText="Asetukset" />
          {renderLoki()}
        </ShowChildren>
        <ShowChildren
          criteriaBool={user.isSystemAdmin}
          criteriaTxt="_showAsetuksetTab"
          source="EdgeDrawer">
          {renderAsetukset()}
        </ShowChildren>
      </List>
      <Divider />
      <List></List>
    </Box>
  );

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      disableSwipeToOpen={false}
      ModalProps={{
        keepMounted: false,
      }}>
      {renderList()}
    </SwipeableDrawer>
  );

  function renderTilaus() {
    // get tilaustext, remove "Tilaus" from it and use it as secondary text for ListItemText
    let _tilausText = "";
    if (keikkaData && keikkaData.tila && typeof keikkaData.tila.keikkaTilaSelite === "string") {
      _tilausText = keikkaData.tila.keikkaTilaSelite.replace("Tilaus", "");
    }
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={tilausClick}>
          <ListItemIcon>
            <TilausIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary={"Tilaus " + keikkaData.keikkaId} secondary={_tilausText} />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderToimitus() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={toimitusClick}>
          <ListItemIcon>
            <ToimitusIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Toimitus" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderKuvat() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={kuvatClick}>
          <ListItemIcon>
            <KuvatIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Liitteet" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderToiminnot() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={toiminnotClick}>
          <ListItemIcon>
            <ToiminnotIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Toiminnot" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderLaskutus() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={hintaClick}>
          <ListItemIcon>
            <HinnatIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Laskutus" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderTarjous() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={tarjousClick}>
          <ListItemIcon>
            <TarjousIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Tarjous" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderSeuranta() {
    let _seurantaText = "Seuranta";
    if (keikkaData.tila.keikkaTilaId == 9) {
      // 9 = toimitettu
      _seurantaText = "Arvosana";
    }
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={processClick}>
          <ListItemIcon>
            <SeurantaIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary={_seurantaText} />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderLoki() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={viestitClick}>
          <ListItemIcon>
            <LokiIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Loki" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }

  function renderAsetukset() {
    return (
      <ListItem disablePadding>
        <ListItemButton onClick={asetuksetClick}>
          <ListItemIcon>
            <AsetuksetIcon style={{ fontSize: fontSize }} />
          </ListItemIcon>
          <ListItemText primary="Asetukset" />
          <ArrowForwardIcon style={styles.arrowForward} />
        </ListItemButton>
      </ListItem>
    );
  }
}

EdgeDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
};

export default EdgeDrawer;
